import { Injectable } from '@angular/core';
import { TabWithDropdown } from '@tripointe/tripointe-cms/types';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomesNavigationService {
  homeDocumentsListStatsCount$: BehaviorSubject<TabWithDropdown[]> = new BehaviorSubject([
    {
      name: 'documents',
      statsCount: null,
      archived: false
    }
  ]);
  homeDocumentsListArchivedStatus$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor() {}

  setHomeDocumentsListStatsCount(newStats: TabWithDropdown[]): void {
    this.homeDocumentsListStatsCount$.next(newStats);
  }

  getHomeDocumentsListStatsCount(): Observable<TabWithDropdown[]> {
    return this.homeDocumentsListStatsCount$.asObservable();
  }

  setHomeDocumentsListArchivedStatus(newStatus: boolean): void {
    this.homeDocumentsListArchivedStatus$.next(newStatus);
  }

  getHomeDocumentsListArchivedStatus(): Observable<boolean> {
    return this.homeDocumentsListArchivedStatus$.pipe(filter(value => value !== null));
  }
}
